/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-30 10:09:32
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-06-19 15:00:05
 * @FilePath: /ckb-client-h5-fed/src/atoms/User.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { atom } from 'jotai';
// import { Site } from '@/const/enum';
// import { CustomerRes } from '@/common/Layout/Header';
import { CACHE_STATION_NAME } from '@/const/staticURL';
import { lang } from '@/i18n/i18n';
import { CustomerDetailRespDTO } from '@/service/customer';
import { ENUM_SYSTEM_SOURCE } from '@/common/Enums';
import { mapStationList } from '../common/Maps';

export type UserDetailType = CustomerDetailRespDTO & {
	membership: {
		templateLevel: number;
	};
};
/** 客服信息数量 */
const serviceNum = atom<number>(0);
/** 首页是否启用 */
const enableIndex = atom(mapStationList.get('JapanStation'));

/** 当前用户是2b、还是2c的 */
export const systemUserSource = atom<ENUM_SYSTEM_SOURCE>(
	ENUM_SYSTEM_SOURCE.D2C
);

// const getDefaultStation = () => {
//     if (lang === undefined) {
//         return (
//             (window.localStorage.getItem(CACHE_STATION_NAME) as Site) || Site.JP
//         );
//     }
//     if (lang === 'ja') {
//         return Site.JP;
//     } else if (lang === 'ko') {
//         return Site.KR;
//     } else if (lang === 'en') {
//         return Site.UK;
//     }
// };
// /** 站点 */
// const stationCode = atom<Site>(getDefaultStation() ?? Site.JP);

/** 汇率 */
const exchangeRate = atom<number>(0);

export default {
	exchangeRate,
	serviceNum,
	enableIndex
};
